import { ModelSagres } from "@/types/model-sagres"
export class Certidao extends ModelSagres {
    Id: number
    BaseLegal: string 
    Detalhamento: string
    DetalheBaseLegal: string
    Fonte: string
    IdBaseLegal: number
    Resultado: boolean
    CpfUsuarioCadastro: string
    UsuarioCadastro: string
    CpfUsuarioUltAlt: string
    UsuarioUltAlt: string
    DataCadastro: Date
    DataUltAlt: Date

    constructor(obj?: any) {
        super();
        if (obj) {
            this.Id = obj.Id
            this.BaseLegal = obj.BaseLegal;
            this.Detalhamento = obj.Detalhamento;
            this.DetalheBaseLegal = obj.DetalheBaseLegal;
            this.Fonte = obj.Fonte;
            this.IdBaseLegal = obj.IdBaseLegal;
            this.Resultado = obj.Resultado;
            this.CpfUsuarioCadastro = obj.CpfUsuarioCadastro
            this.UsuarioCadastro = obj.UsuarioCadastro
            this.CpfUsuarioUltAlt = obj.CpfUsuarioUltAlt
            this.UsuarioUltAlt = obj.UsuarioUltAlt === null ? obj.UsuarioCadastro : obj.UsuarioUltAlt
            this.DataCadastro = new Date(obj.DataCadastro)
            this.DataUltAlt =  obj.DataUltAlt === null ? new Date(obj.DataCadastro) : new Date(obj.DataUltAlt)
        }
    }
}